var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import * as Const from "@utils/Const";
import { useAsync } from "react-async";
import { PromiseHttp } from "@utils/api/HttpUtil";
import { pages } from "@recoil/Store";
import { useRecoilValue } from "recoil";
import Pagenation from "@components/common/Pagenation";
import dayjs from "dayjs";
export default function BoardList(props) {
    var _a, _b, _c, _d, _e, _f, _g;
    const { menu, item, setItem, } = props;
    let token = localStorage.getItem(Const.TOKEN);
    const lang = localStorage.getItem(Const.LANG_TYPEA);
    let pageInfo = useRecoilValue(pages);
    const [page, setPage] = useState(pageInfo);
    function handlePage(pages) {
        setPage(Object.assign(Object.assign({}, page), { pageNum: pages - 1 }));
    }
    const [list, setList] = useState([]);
    let appPath = `?page=${page.pageNum}&size=${page.size}`;
    // API
    const { data: data } = useAsync({
        promiseFn: PromiseHttp,
        httpMethod: Const.API_GET,
        appPath: `/open/board/${(_a = item.depth2) === null || _a === void 0 ? void 0 : _a.menuName}/detail?lang=KOR`,
        appQuery: {},
        userToken: "",
        watch: appPath + lang + ((_b = item.depth2) === null || _b === void 0 ? void 0 : _b.menuName),
    });
    useEffect(() => {
        var _a;
        if (data) {
            if (data.codeNum == Const.API_200) {
                List(data.body);
                setItem((prev) => (Object.assign(Object.assign({}, prev), { boardId: data.body.boardId })));
                if (((_a = item.depth2) === null || _a === void 0 ? void 0 : _a.menuName) !== data.body.boardType) {
                    handlePage(1);
                }
            }
        }
    }, [data]);
    const List = (board) => __awaiter(this, void 0, void 0, function* () {
        let data = null;
        data = yield PromiseHttp({
            httpMethod: Const.API_GET,
            appPath: `/open/board/${board.boardId}/list${appPath}`,
            appQuery: {},
            userToken: "",
        });
        if (data) {
            if (data.codeNum == Const.API_200) {
                sessionStorage.setItem("boardId", board.boardId);
                setList(data.body);
                setPage(Object.assign(Object.assign({}, data.data.page), { totalPages: Math.ceil(data.data.page.totalElements / page.size) }));
            }
            else {
            }
        }
    });
    const handleView = (e, val) => {
        setItem((prev) => (Object.assign(Object.assign({}, prev), { type: Const.TYPE_V, postId: val.postId })));
    };
    const handleAdd = (e) => {
        setItem((prev) => (Object.assign(Object.assign({}, prev), { type: Const.TYPE_C })));
    };
    return (_jsx(_Fragment, { children: _jsxs("section", Object.assign({ className: "board-main" }, { children: [_jsxs("div", Object.assign({ className: "board-header" }, { children: [_jsxs("h4", { children: ["\uAC8C\uC2DC\uD310 \uAD6C\uBD84: ", (_c = item.depth2) === null || _c === void 0 ? void 0 : _c.menuName] }), ((_d = item.depth2) === null || _d === void 0 ? void 0 : _d.url) !== Const.URL_CONTACT && _jsx("button", Object.assign({ className: "new-btn", onClick: (e) => handleAdd(e) }, { children: "\uC2E0\uADDC" }))] })), ((_e = item.depth2) === null || _e === void 0 ? void 0 : _e.url) === Const.URL_NOTICE && _jsx(Notice, { list: list, handleView: handleView }), ((_f = item.depth2) === null || _f === void 0 ? void 0 : _f.url) === Const.URL_FAQ && _jsx(Faq, { list: list, handleView: handleView }), ((_g = item.depth2) === null || _g === void 0 ? void 0 : _g.url) === Const.URL_CONTACT && _jsx(Contact, { list: list, handleView: handleView }), _jsx(Pagenation, { page: page, handlePage: handlePage }), _jsx("div", { className: "footer-box" })] })) }));
}
function Notice(props) {
    const { list, handleView } = props;
    return (_jsx(_Fragment, { children: _jsxs("table", Object.assign({ className: "board-table" }, { children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", {}), _jsx("th", { children: "\uC81C\uBAA9" }), _jsx("th", { children: "\uC0DD\uC131\uC2DC\uAC04" }), _jsx("th", { children: "\uCCA8\uBD80" })] }) }), _jsx("tbody", { children: list && list.map((item, i) => _jsxs("tr", Object.assign({ onClick: (e) => handleView(e, item) }, { children: [_jsx("td", { children: i + 1 }), _jsx("td", { children: item.title }), _jsx("td", { children: item.createdAt ? dayjs(item.createdAt).format("YYYY/MM/DD") : '-' }), _jsx("td", { children: item.attached ? 'O' : 'X' })] }), item.postId)) })] })) }));
}
function Faq(props) {
    const { list, handleView } = props;
    return (_jsx(_Fragment, { children: _jsxs("table", Object.assign({ className: "board-table" }, { children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", {}), _jsx("th", { children: "\uC81C\uBAA9" }), _jsx("th", { children: "\uC0DD\uC131\uC2DC\uAC04" })] }) }), _jsx("tbody", { children: list && list.map((item, i) => _jsxs("tr", Object.assign({ onClick: (e) => handleView(e, item) }, { children: [_jsx("td", { children: i + 1 }), _jsx("td", { children: item.title }), _jsx("td", { children: item.createdAt ? dayjs(item.createdAt).format("YYYY/MM/DD") : '-' })] }), item.postId)) })] })) }));
}
function Contact(props) {
    const { list, handleView } = props;
    return (_jsx(_Fragment, { children: _jsxs("table", Object.assign({ className: "board-table" }, { children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", {}), _jsx("th", { children: "\uC81C\uBAA9" }), _jsx("th", { children: "\uC0DD\uC131\uC2DC\uAC04" }), _jsx("th", { children: "\uB2F5\uAE00" }), _jsx("th", { children: "\uCCA8\uBD80" })] }) }), _jsx("tbody", { children: list && list.map((item, i) => _jsxs("tr", Object.assign({ onClick: (e) => handleView(e, item) }, { children: [_jsx("td", { children: i + 1 }), _jsx("td", { children: item.title }), _jsx("td", { children: item.createdAt ? dayjs(item.createdAt).format("YYYY/MM/DD") : '-' }), _jsx("td", { children: item.hasReply ? 'O' : 'X' }), _jsx("td", { children: item.attached ? 'O' : 'X' })] }), item.postId)) })] })) }));
}
;
